import { Form } from 'antd';
import cronstrue from 'cronstrue';
import 'cronstrue/locales/zh_CN.js';
import PropTypes from 'prop-types';
import { Cron } from 'react-js-cron';
import 'react-js-cron/styles.css';

const DEFAULT_CRON = '0 * * * *';
const FIVE_PART_CRON_PATTERN = /^\S+\s+\S+\s+\S+\s+\S+\s+\S+$/;
const CRON_ALLOWED_PERIODS = ['week', 'day', 'hour'];
const CRON_LOCALE = {
  everyText: '每',
  emptyMonths: '每月',
  emptyMonthDays: '每月每天',
  emptyMonthDaysShort: '月中日期',
  emptyWeekDays: '每周每天',
  emptyWeekDaysShort: '星期',
  emptyHours: '每小时',
  emptyMinutes: '每分钟',
  emptyMinutesForHourPeriod: '每分钟',
  yearOption: '年',
  monthOption: '月',
  weekOption: '周',
  dayOption: '日',
  hourOption: '小时',
  minuteOption: '分钟',
  rebootOption: '重启',
  prefixPeriod: '每',
  prefixMonths: '在',
  prefixMonthDays: '在',
  prefixWeekDays: '在',
  prefixWeekDaysForMonthAndYearPeriod: '以及',
  prefixHours: '在',
  prefixMinutes: ':',
  prefixMinutesForHourPeriod: '在',
  suffixMinutesForHourPeriod: '分钟',
  errorInvalidCron: 'cron 表达式无效',
  clearButtonText: '清空',
  weekDays: [
    // 顺序很重要，索引会作为值使用
    '周日', // 周日必须始终排在第一位，它是“0”
    '周一',
    '周二',
    '周三',
    '周四',
    '周五',
    '周六',
  ],
  months: [
    // 顺序很重要，索引会作为值使用
    '一月',
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月',
  ],
  // 顺序很重要，索引会作为值使用
  altWeekDays: [
    '周日', // 周日必须始终排在第一位，它是“0”
    '周一',
    '周二',
    '周三',
    '周四',
    '周五',
    '周六',
  ],
  // 顺序很重要，索引会作为值使用
  altMonths: [
    '一月',
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月',
  ],
};

const formatCronDescription = (cron) => {
  try {
    return cronstrue.toString(String(cron || DEFAULT_CRON), {
      locale: 'zh_CN',
      use24HourTimeFormat: true,
    });
  } catch {
    return '无法解析定时规则';
  }
};

const CronEditor = ({ value, onChange }) => (
  <Cron
    value={value || DEFAULT_CRON}
    setValue={(nextValue) => onChange?.(nextValue)}
    locale={CRON_LOCALE}
    allowedPeriods={CRON_ALLOWED_PERIODS}
    allowEmpty="never"
    clearButton={false}
    allowedDropdowns={['period', 'months', 'month-days', 'week-days', 'hours', 'minutes']}
    clockFormat="24-hour-clock"
    defaultPeriod="day"
    shortcuts={false}
  />
);

CronEditor.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

const CronFormItem = () => {
  const cron = Form.useWatch('cron');

  return (
    <Form.Item
      name="cron"
      label="定时规则"
      initialValue={DEFAULT_CRON}
      extra={formatCronDescription(cron)}
      rules={[
        {
          required: true,
          message: '请输入定时规则',
        },
        {
          pattern: FIVE_PART_CRON_PATTERN,
          message: '定时规则必须是 5 段 cron 表达式',
        },
      ]}
    >
      <CronEditor />
    </Form.Item>
  );
};

export { CronEditor, CronFormItem, formatCronDescription };
